import gql from 'graphql-tag'

export const adminUpdateSubscriptionActivationState = gql`
  mutation AdminUpdateSubscriptionActivationState(
    $input: AdminUpdateSubscriptionActivationStateInput!
  ) {
    adminUpdateSubscriptionActivationState(input: $input) {
      success
      message
      deviceId
      activationState
    }
  }
`
